<template>
  <div>
    <div class="risk-ip" v-if="this.$store.state.productLoading">
      <not-available v-if="getList.length === 0" title="风险IP画像">
        <div class="product-introduce">
          <p
            class="bottom"
          >黑灰产从业者为了隐藏自己的真实IP，同时也为了绕过甲方的IP风控策略，利用大量的IP资源（比如代理IP）作为跳板，进而发动网络攻击。准确地识别攻击者的源IP，以及攻击者使用的跳板IP，能够有效帮助甲方厂商完善基于IP的风控策略。</p>
          <p>
            <span class="product">风险IP画像</span>实时判定IP状态，采取打分机制，量化风险值，精准识别恶意动态IP，解决由此带来的爬虫、撞库、薅羊毛等风险。
          </p>
          <p>产品优势： 近1亿风险IP标签数据，每日20-30万新增数据；覆盖秒拨、代理及数据中心等IP池</p>
          <p>更新频率：支持秒级更新</p>
          <p>交付方式：SaaS API或私有化部署</p>
        </div>
      </not-available>
      <div class="risk-ip-wrap" v-if="getList.length>0">
        <div class="risk-ip-header">
          <h3 v-if="getList.length === 1">{{selectName}}</h3>
          <div class="select active" v-if="getList.length>1">
            <span @click="selectProduct">
              {{selectName}}
              <i class="iconfont iconsanjiaoxingbeifen" :class="{active:show}"></i>
            </span>
            <ul class="select-list" v-if="show">
              <li
                :class="{active:type ===item.value}"
                v-for="(item,index) in getList"
                :key="index"
                @click="selectItem(item.value)"
              >{{item.label}}</li>
            </ul>
          </div>
          <a :href="selectUrl" target="_blank">
            <i class="iconfont iconkzt_jswd1"></i>
            技术文档
          </a>
        </div>
        <component :is="getComponent"></component>
      </div>
    </div>
    <loading v-if="!this.$store.state.productLoading"></loading>
  </div>
</template>

<script>
import riskIpOnlineV2 from './components/riskIpOnlineV2'
import riskIpOfflineV2 from './components/riskIpOfflineV2'
import notAvailable from '../../components/mark/notAvailable'
import { DOCUMENT_CENTER } from '@/config.js'
export default {
  name: 'riskIp',
  components: { riskIpOnlineV2, riskIpOfflineV2, notAvailable },
  data () {
    return {
      show: false,
      type: null,
      list: [
        {
          label: 'IP画像-在线API版本',
          value: 'blackipv2_online',
          url: DOCUMENT_CENTER + '/riskip/api3.0.html',
          component: 'riskIpOnlineV2'
        },
        {
          label: 'IP画像-私有化版本',
          value: 'blackipv2_offline',
          url: DOCUMENT_CENTER + '/riskphone/private-api.html',
          component: 'riskIpOfflineV2'
        },
      ]
    }
  },
  methods: {
    selectProduct () {
      this.show = !this.show
    },
    selectItem (type) {
      this.type = type
      this.show = false
    }
  },
  computed: {
    getList () {
      const data = []
      this.$store.state.product.map(val => {
        if (val.busi === 'blackipv2_online' || val.busi === 'blackipv2_offline') {
          const arr = this.list.filter(value => value.value === val.busi)
          data.push(...arr)
          if (this.$route.params.busi && data.some(item => item.value === this.$route.params.busi)) {
            this.type = this.$route.params.busi
          } else if (data.length > 0) {
            this.type = data[0].value
          }
        }
      })
      return data
    },
    selectName () {
      return this.getList.find(val => val.value === this.type).label
    },
    selectUrl () {
      return this.getList.find(val => val.value === this.type).url
    },
    getComponent () {
      return this.getList.find(val => val.value === this.type).component
    }
  }
}
</script>

<style lang="scss">
.risk-ip {
  padding: 30px 40px;
  .risk-ip-wrap {
    .risk-ip-header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 24px;

      .select {
        position: relative;
        font-size: 18px;
        font-weight: 500;
        color: rgba(29, 36, 60, 1);
        line-height: 30px;

        &.active {
          cursor: pointer;
        }

        i {
          display: inline-block;
          transform: rotate(90deg);
          margin-left: 8px;
          &.active {
            transform: rotate(270deg);
          }
        }

        .select-list {
          position: absolute;
          top: 38px;
          z-index: 99;
          width: 100%;
          background: rgba(255, 255, 255, 1);
          box-shadow: 0 4px 8px 0 rgba(17, 39, 98, 0.04);
          padding: 12px 0;

          li {
            height: 40px;
            line-height: 40px;
            font-size: 16px;
            font-weight: 400;
            color: rgba(29, 36, 60, 1);
            /*margin-bottom: 12px;*/
            text-align: left;
            padding-left: 20px;
            &:hover {
              background: rgba(220, 234, 255, 1);
            }
            &.active {
              background: rgba(220, 234, 255, 1);
            }
          }
        }
      }

      a {
        width: 92px;
        height: 32px;
        background: rgba(0, 61, 146, 1);
        border-radius: 4px;
        line-height: 32px;
        text-align: center;
        font-size: 14px;
        color: rgba(255, 255, 255, 1);

        i {
          position: relative;
          top: 1px;
        }
      }
    }
  }
}
</style>
